import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { linebreak } from '../../../lib/formaterValues';
import { useHookInterfaces } from '../../extension-interop/hooks/useHookInterfaces';
import { labelsFeatureSelector } from '../../pricing/selectors';
import { visibleActions } from '../actions';
import { createCustomAction } from '../actions/CustomAction';

export const useActionOptions = () => {
  const intl = useIntl();
  const labelsEnabled = useSelector(labelsFeatureSelector);

  const { data: hookInterfaces } = useHookInterfaces({
    canInvoke: true,
    type: 'queue_action',
  });

  return useMemo(
    () => [
      ...visibleActions
        .filter(a => a.groupIntlKey !== 'labels' || labelsEnabled)
        .map(a => ({
          ...a,
          name: intl.formatMessage({
            id: `features.queueSettings.rules.actions.${a.intlKey}.name`,
          }),
          description: intl.formatMessage(
            {
              id: `features.queueSettings.rules.actions.${a.intlKey}.description`,
            },
            {
              linebreak,
            }
          ),
          descriptionShort: intl.formatMessage({
            id: `features.queueSettings.rules.actions.${a.intlKey}.descriptionShort`,
          }),
        })),
      ...(hookInterfaces?.results.map(action => ({
        ...createCustomAction(action),
        name: action.name,
        description: action.description,
        descriptionShort: action.description,
      })) ?? []),
    ],
    [hookInterfaces?.results, intl, labelsEnabled]
  );
};
